@if (col.type === 'tag') {
  <!-- Generic tag rendering - data provides label and color -->
  <div class="status-tag">
    <app-tag
      [label]="tag(col.field)?.label!"
      [color]="tag(col.field)?.color!"
      size="small">
    </app-tag>
  </div>
} @else if (col.type === 'name') {
  @if (col.showAvatar) {
    <div class="avatar-wrapper" (click)="$event.stopPropagation()">
      <app-avatar
        [userId]="col.imageField ? undefined : (col.userIdField ? nestedId(col.userIdField) : undefined)"
        [imageUrl]="col.imageField ? nestedText(col.imageField) : undefined"
        [name]="text(col.field)!"
        [extraInfo]="col.extraField ? nestedText(col.extraField) : undefined"
        [size]="40"
        [lazyLoad]="false"
        [showTooltip]="false"
      ></app-avatar>
    </div>
  } @else {
    {{ value(col.field) || '-' }}
  }
} @else if (col.renderAsHtml) {
  <div [innerHTML]="value(col.field) || '-'"></div>
} @else if (col.tooltipField && nestedText(col.tooltipField)) {
  <span
    [pTooltip]="nestedText(col.tooltipField)"
    tooltipPosition="top"
    class="cell-with-tooltip"
  >{{ value(col.field) || '-' }}</span>
} @else if (col.subField) {
  <div class="cell-two-lines">
    <span class="cell-main">{{ value(col.field) || '-' }}</span>
    @if (value(col.subField)) {
      <span class="cell-sub">{{ value(col.subField) }}</span>
    }
  </div>
} @else {
  <span class="cell-text" [attr.title]="value(col.field) || null">{{ value(col.field) || '-' }}</span>
}
